import { render, staticRenderFns } from "./UcrForm.vue?vue&type=template&id=7f4e1e3c&"
import script from "./UcrForm.vue?vue&type=script&lang=js&"
export * from "./UcrForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports